module.exports = __webpack_public_path__ + "static/media/plus-circle.38ed38ba.svg";